exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n*[data-v-3da2287c] {\n  font-family: Moderat;\n  font-style: normal;\n  font-weight: normal;\n}\n.modal-contents[data-v-3da2287c] {\n  width: 356px;\n  text-align: left;\n}\n.modal-instruction[data-v-3da2287c] {\n  font-size: 14px;\n  line-height: 130%;\n  color: #1b1e22;\n}\n.edit-form[data-v-3da2287c] {\n  margin-top: 8px;\n}\n.form-control[data-v-3da2287c] {\n  margin-bottom: 0;\n  margin-top: 1px;\n}\n.form-error[data-v-3da2287c] {\n  padding-top: 4px;\n  color: red;\n  font-size: 12px;\n  height: 18px;\n}\n", ""]);

// exports
